export * from './lib/is-booking-portal';
